import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBookmarkRemove: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBookmarkRemove"><Path d="M20 7.64052L22.6135 6.7258L23.2742 8.61352L1.38649 16.2742L0.725784 14.3865L4 13.2405V2H20V7.64052Z" fill="currentColor"/><Path d="M4 22.7232V17.4784L20 11.8784V22.7232L12 18.1517L4 22.7232Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBookmarkRemove;
